// PAY-3511: a Cash to Close request's eligibility status. Mirrors the BFF CashToCloseEligibilityStatus
// serialized onto ClientRequestDetail.ctcEligibilityStatus. Single source of truth for these literals so the
// "is this window-missed?" concept isn't re-derived against magic strings across views.
export enum CtcEligibilityStatus {
    Eligible = 'Eligible',
    DeliveryOnClosingDate = 'DeliveryOnClosingDate',
    ClosingToday = 'ClosingToday',
    DeliveryAfterClosing = 'DeliveryAfterClosing',
    SameDayWindowMissed = 'SameDayWindowMissed',
}

/**
 * Shared predicate for "has the same-day payment window passed?".
 *
 * The comparison is case-insensitive on purpose: `ctcEligibilityStatus` arrives as a serialized
 * enum whose casing isn't contractually guaranteed, so the tolerance lives here in
 * exactly one place rather than being copy-pasted as `?.toLowerCase() === 'samedaywindowmissed'` at
 * every call site.
 *
 * The other four enum members (Eligible, DeliveryOnClosingDate, ClosingToday, DeliveryAfterClosing)
 * serve as named constants documenting the known upstream values; the field stays `string | null`
 * because inbound casing isn't guaranteed, so typing it as the enum would create a false guarantee.
 */
export const isSameDayWindowMissed = (status?: string | null): boolean =>
    (status ?? '').toLowerCase() === CtcEligibilityStatus.SameDayWindowMissed.toLowerCase();
